import { useEffect, useState } from 'react';
import { User, useUser_GetCurrentUserQuery } from 'queries';

import { NotificationSeverity, showAlert } from 'utils/notification-manager';

export default function useCurrentUser(forceReload = false) {
  const [currentUser, setCurrentUser] = useState<Partial<User> | undefined>();

  const { data: currentUserData } = useUser_GetCurrentUserQuery({
    fetchPolicy: forceReload ? 'network-only' : undefined,
    notifyOnNetworkStatusChange: forceReload ? true : undefined,
    onError: (e) => {
      showAlert({
        message: 'Error getting current user: ' + e.message,
        severity: NotificationSeverity.ERROR,
      });
    },
  });

  useEffect(() => {
    setCurrentUser(currentUserData?.data);
  }, [currentUserData]);

  return currentUser;
}
